export default "__VITE_ASSET__445bacbc__"